import { Component, Input } from '@angular/core';
import { PageOptimizationApproval } from '../../../../shared/models/required-actions/page-optimization-approval';

@Component({
  selector: 'app-page-optimization-approval',
  templateUrl: './page-optimization-approval.component.html',
  styleUrls: ['./page-optimization-approval.component.css']
})
export class PageOptimizationApprovalComponent {
  @Input() requiredAction: PageOptimizationApproval;
}
